var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var dialogModel = Backbone.Model.extend({
  defaults: {
    automaticTitle:true
  },
  initialize: function (options) {

  	// remove buttons which are not alowed for the current user
  	if (_.has(options, 'buttons')) {


      var buttonsRight = _.pickBy(options.buttons.right, function (o) {
        return App.session.user.hasRole(o.roles)
      })

      var buttonsLeft = _.pickBy(options.buttons.left, function (o) {
        return App.session.user.hasRole(o.roles)
      })
  		this.set('buttons', {right:buttonsRight,left:buttonsLeft})
  	}

  	// remove tabs which are not alowed for the current user
  	if (_.has(options, 'tabs')) {

  		var tabs = _.pickBy(options.tabs, function (o) {
  		  return App.session.user.hasRole(o.roles)
  		})
  		this.set('tabs', tabs)
  	}
  }
  // 
  // 

})

module.exports = dialogModel



// WEBPACK FOOTER //
// ./js/common/dialog-model.js